let lastScrollY = window.scrollY;
let ticking = false;

const footer = document.querySelector('.how-to-footer');

if (footer) {

  window.addEventListener('scroll', () => {

    if (!ticking) {

      window.requestAnimationFrame(() => {

        const currentScrollY = window.scrollY;

        const scrollingDown = currentScrollY > lastScrollY;
        const pastThreshold = currentScrollY > 100;

        if (scrollingDown && pastThreshold) {
          // hide
          footer.style.setProperty('--footer-y', '100%');
          footer.style.setProperty('--footer-opacity', '0');
        } else {
          // show
          footer.style.setProperty('--footer-y', '0%');
          footer.style.setProperty('--footer-opacity', '1');
        }

        lastScrollY = currentScrollY;
        ticking = false;

      });

      ticking = true;
    }
  });
}